<template>
  <div class="page_container">
    <div class="title_container">
      <page-title title="ריכוז מועמדים"></page-title>
    </div>
    <div v-if="is_loading" class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div class="is-flex">
      <div v-if="getUnselectedOffers.length > 0" style="border-right: 1px solid rgba(0, 0, 0, 0.1); padding-right: 30px;">
        <div v-for="offer in getUnselectedOffers" :key="offer.id" class="offer">
          <div class="is-flex is-align-items-center">
            <checkbox v-model="offer.is_selected" :checked="offer.is_selected" :disabled="disableTheSelection(offer.status.name)"></checkbox>
            <div class="horizontal_space"></div>
            <div class="horizontal_space"></div>
            <link-entity :payload="offer.applicant"></link-entity>
          </div>
          <div>
            <div class="rtl margin-top margin_bottom_10px">
              <b>ציפיות שכר:</b> {{ offer.applicant.salary_expectations_comment }}
              <br />
              <b>Sent at:</b> {{ $moment(offer.sent_at).format('DD/MM/YYYY')  }}
              <br />
            </div>
            <message class="offer_message" :payload="offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }">
            </message>
            <offer-status :payload="offer" class="offer_status"></offer-status>
          </div>
        </div>
      </div>
      <div v-if="selected_offers.length > 0" dir="rtl" class="applicants">
        <email-position-applicant :ref="`selected_applicant_${offer.id}`" v-for="offer in selected_offers" :offer="offer" :key="offer.id"></email-position-applicant>
        <br>
        <br>
        <a @click="previewAndSendEmail" class="button is-info">Preview and send email</a>
      </div>
      <div dir="rtl" style="border-left: 1px solid rgba(0, 0, 0, 0.1); padding-left: 30px;">
        <div class="relative">
          <ul id="sort">
            <li class="sortable_item" v-for="offer in selected_offers" :key="offer.id" :offer_id="offer.id">
              <div class="is-flex is-align-items-center">
                <checkbox v-model="offer.is_selected" :checked="offer.is_selected"></checkbox>
                <div class="horizontal_space"></div>
                <div class="horizontal_space"></div>
                <link-entity :payload="offer.applicant"></link-entity>
              </div>
              <div>
                <message class="offer_message" :payload="offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }">
                </message>
                <offer-status :payload="offer" class="offer_status"></offer-status>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'
import PageTitle from '@/components/PageTitle'
import Message from '@/components/Message'
import LinkEntity from '@/components/LinkEntity'
import Checkbox from '@/components/Checkbox'
import OfferStatus from '@/components/OfferStatus'
import EmailPositionApplicant from '@/components/EmailPositionApplicant'
import Sortable from 'sortablejs'
export default {
  name: 'select-email-position-applicants',
  data () {
    return {
      is_loading: true,
      offers: [],
      array: [],
      selected_offers: [],
      position_id: this.$route.query.position_id,
      position: undefined
    }
  },
  created () {
    this.init()
  },
  mounted () {
    Sortable.create(document.getElementById('sort'), {
      draggable: 'li.sortable_item',
      animation: 80,
      sort: true,
      onUpdate: (event) => {
        let new_array = []
        for (let i = 0; i < event.to.children.length; i++) {
          let child = event.to.children[i]
          let offer_id = child.getAttribute('offer_id')
          new_array.push(this.offers.filter(offer => offer.id == offer_id)[0])
        }
        this.selected_offers = new_array
        this.$forceUpdate()
      }
    })
  },
  watch: {
    offers: {
      handler (new_value, old_value) {
        this.sortOffersBasedOnSelectedOffers()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getRedList', 'getPurpleList', 'getGreenList']),
    getSortedOffers () {
      return this.offers.slice().sort(this.sortSentAt)
    },
    getUnselectedOffers () {
      return this.getSortedOffers.filter(offer => !offer.is_selected)
    }
  },
  methods: {
    init () {
      this.is_loading = true
      let offers_request = this.$network_utils.getResourceOffers({ resource_type: 'Position', resource_id: this.position_id, statuses: 'awaiting_company_sent,company_process,interview,company_never_replied,expired_after_sent' })
      let position_request = this.$network_utils.getPosition({ id: this.position_id })
      let requests = [offers_request, position_request]
      this.$caller.axios.all(requests).then(response => {
        this.offers = response[0]
        this.position = response[1]
        this.is_loading = false
      })
    },
    disableTheSelection (status) {
      console.log(status)
      return status == 'expired_after_sent'
    },
    sortByColor (a, b) {
      return this.getSortOrder(a) - this.getSortOrder(b)
    },
    sortSentAt (a, b) {
      return new Date(b.sent_at) - new Date(a.sent_at)
    },
    getSortOrder (offer) {
      if (this.getGreenList.map(s => s.name).includes(offer.status.name)) {
        return 1
      }
      if (this.getPurpleList.map(s => s.name).includes(offer.status.name)) {
        return 2
      }
      if (this.getRedList.map(s => s.name).includes(offer.status.name)) {
        return 3
      }
      return 0
    },
    previewAndSendEmail () {
      let text = ''
      let files = []
      let offer_list = []
      this.selected_offers.forEach(selected_offer => {
        let ref = this.$refs[`selected_applicant_${selected_offer.id}`][0]
        text += ref.getInfo() + '<br><br>'
        files.push(...ref.getSelectedFiles())
        offer_list.push({ id: selected_offer.id, text: ref.getTextInfo() })
      })
      this.create({
        designator: 'position-applicants-email-sender',
        component_name: 'PositionApplicantsEmailSender',
        modal_title: 'ריכוז מועמדים',
        position: this.position,
        text,
        offer_list,
        files
      })
    },
    sortOffersBasedOnSelectedOffers () {
      this.selected_offers = this.offers.filter(offer => offer.is_selected).sort((a, b) => {
        return this.selected_offers.indexOf(a) - this.selected_offers.indexOf(b)
      })
      if (this.selected_offers.length > 0) {
        this.selected_offers.push(this.selected_offers.shift())
      }
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    PageTitle,
    Message,
    LinkEntity,
    Checkbox,
    OfferStatus,
    EmailPositionApplicant
  }
}
</script>
<style scoped>
  .page_container {
    padding: 30px;
  }
  .title_container {
    margin-top: 10px;
  }
  .submit_button {
    position: sticky;
    top: 40px;
  }
  .sortable_item {
    cursor: pointer;
    padding: 5px 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.2);
    border-radius: 4px;
    width: 400px;
    background-color: #f2f2f2;
  }
  .applicants {
    margin-right: 20px;
    margin-left: 20px;
    width: 100%;
  }
  .offer_status {
    margin-top: 10px;
    font-size: 11px;
  }
  .offer_message {
    font-size: 12px;
  }
  .offer {
    min-width: 250px;
    padding-top: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
</style>
